import customer from './modules/customer';
import order from './modules/order';
import approval from './modules/approval';
import collection from './modules/collection';
import risk from './modules/risk';
import remind from './modules/remind';
import repayReport from './modules/repayReport';
import repayOverDueReport from './modules/repayOverDueReport';
import platformCollection from './modules/platformCollection';
import custServiceWorkOrder from './modules/custServiceWorkOrder';
import collectorTotalFollow from './modules/collectorTotalFollow';
import teleMarket from "./modules/teleMarket";
import coupon from './modules/coupon';
import  HumanReviewDataSet from './modules/HumanReviewDataSet';
import payroll from './modules/payroll';
export default {
  code: 'ti',
  label: 'ไทย',

  error: 'error',
  tips: 'คำใบ้',
  reset: 'ตั้งค่าใหม่',
  search: 'สอบถาม',

  searchColAll: 'Consulta',
  searchColCur: 'El día de la consulta',
  searchColHis: 'Historial de consulta',
  exportFile:"ส่งออก",
  check: 'check',
  edit: 'edit',
  more: 'more',
  delete: 'ลบออก',
  enter: 'กรุณาเข้า',
  select: 'โปรดเลือก',
  show: 'แสดงผล',
  hide: 'ซ่อน',
  confirm: 'ยืนยัน',
  cancel: 'ยกเลิก',
  sort: 'sort',
  action: 'ดำเนินงาน',
  add: 'Add',
  view: 'ตรวจสอบ',
  reorder: 'ตัดสินใจใหม่',
  DeactivateApprover:'ปิดการใช้งานผู้อนุมัติ',
  enableApprover:'เปิดใช้งานผู้อนุมัติ',
  success: 'Success',
  fail: 'Fail',
  userName: 'ชื่อผู้ใช้',
  signOut: 'ออกจากระบบ',
  signIn: 'ล็อกอิน',
  requestFail: 'Request failed, please try again',
  confirmDelete: 'Confirm to delete?',
  oldPassword: 'รหัสผ่านเก่า',
  password: 'รหัสผ่าน',
  newPassword: 'รหัสผ่านใหม่',
  confirmPassword: 'ยืนยันรหัสผ่าน',
  createRepayOrder: 'Create PayOrder',
  balanceOrder: 'สมดุล',
  createRepayUrl: 'Create PayUrl',
  sex: 'Género',
  name: 'ชื่อ',
  birthday: 'Birthday',
  date: 'Date',
  time: 'เวลา',
  man: 'Male',
  woman: 'Female',
  email: 'Buzón de correo',
  addressBook: 'สมุดที่อยู่',
  phone: 'โทรศัพท์',
  phoneNo: 'หมายเลขโทรศัพท์',
  enable: 'Enable',
  disable: 'Disable',
  status: 'Status',
  remark: 'โน้ต',
  saveEdit:'เซฟ',
  decLateFee: 'Solicitar la liberación',
  handle: 'Handle',
  reCreate: 'ReCreate',
  flush: 'Flush',
  createReport: 'Create Report',
  close: 'Close',
  components: {
    total: 'ทั้งหมด',
    items: 'แถบกํากับ',
  },

  home: {
    title: 'หน้าแรก',
    modifyPassword: 'แก้ไขรหัสผ่าน',
    userInfoFail: 'Requesting user information failed, please try again',
    signOutInfo: 'ต้องการออกจากระบบจริงหรือไม่?',
    userNameTips: 'กรุณากรอกชื่อผู้ใช้',
    passwordTips: 'กรุณากรอกรหัสผ่าน',
    earlyMorning: 'Good morning',
    morning: 'Good morning',
    noon: 'Good noon',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    welcome: 'welcome',
    welcomeBack: 'welcome back',
  },
  customer: customer.ti,
  system: {
    title: 'System Management',
    menuList: {
      menu: 'menu',
      title: 'Menu Management',
      index: 'index',
      menuName: 'name',
      icon: 'menu icon',
      type: 'type',
      superiorMenu: 'Superior Menu',
      menuUrl: 'Menu URL',
      menuComponent: 'Menu Component',
      sort: 'sort',
      action: 'action',
      edit: 'edit',
      delete: 'delete',
      add: 'เพิ่ม',
      mainSub: 'main menu',
      submenu: 'sub menu',
      buttonPermission: 'button/permission',
      nameCn: 'Chinese Name',
      nameEn: 'English Name',
      nameEs: 'Es Name',
      nameAr: 'Ar Name',
      nameFr: 'Fr Name',
      nameLang1:'Ti Name',
      preMenu: 'previous menu',
      menuCode: 'menu code',
    },
    userList: {
      title: 'User List',
      index: 'index',
      name: 'name',
      phone: 'phone',
      mail: 'mail',
      time: 'Create Time',
      position: 'Department / post',
      role: 'role',
      app: 'application',
      status: 'status',
      action: 'action',
      add: 'add',
      edit: 'edit',
      password: 'password',
      delete: 'delete',
    },
    roleList: {
      title: 'Role List',
      index: 'index',
      type: 'role type',
      code: 'role code',
      description: 'description',
      time: 'create time',
      action: 'action',
      add: 'add',
      edit: 'edit',
      password: 'password',
      delete: 'delete',
      permission: 'permission',
    },
  },
  order: order.ti,
  account: {
    accountDetail: 'Account Detail',
  },
  postLoan: {
    title: 'Post-loan Management',
  },
  approval: approval.ti,
  HumanReviewDataSet: HumanReviewDataSet.ti,
  collection: collection.ti,
  remind: remind.en,
  risk: risk.en,
  repayReport: repayReport.ti,
  repayOverDueReport: repayOverDueReport.en,
  collectorTotalFollow: collectorTotalFollow.en,
  other: {
    title: 'other',
  },
  platformCollection: platformCollection.ti,
  custServiceWorkOrder: custServiceWorkOrder.en,
  teleMarket: teleMarket.en,
  coupon: coupon.en,
  payroll: payroll.ti
};